/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uploading_AudioInputs */



/**
* | output |
* | --- |
* | "Uploading audio..." |
*
* @param {Uploading_AudioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const uploading_audio = /** @type {((inputs?: Uploading_AudioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploading_AudioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement audio en cours...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio wird hochgeladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento dell'audio...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка аудио...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subiendo audio...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在上传音频……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声ファイルをアップロード中...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो अपलोड हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando áudio...")
	return /** @type {LocalizedString} */ ("Uploading audio...")
});